export default "__VITE_ASSET__CPP9nd1n__"